<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">中标候选人公示列表</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="winCandidateList" border style="width: 100%" class="data-table" v-loading="loading">
                <el-table-column prop="winCandidateBulletinCode" label="公示编号" show-overflow-tooltip />
                <el-table-column prop="winCandidateBulletinName" label="公示名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="startTime" label="开始时间" width="180" align="center" />
                <el-table-column prop="endTime" label="结束时间" width="180" align="center" />
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusName(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
                            查看详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-wrapper">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" background />
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetWinCandidateList } from '@/api/modules/semiProcess'
export default {
    name: 'WinCandidateList',
    data() {
        return {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            projectCode: this.$route.query.projectCode,
            winCandidateList: [],
            loading: false
        }
    },
    mounted() {
        this.getWinCandidateList()
    },
    methods: {
        /**
         * 获取中标候选人公示列表
         */
        getWinCandidateList() {
            this.loading = true
            Api_GetWinCandidateList({
                projectCode: this.projectCode,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.winCandidateList = res.data.records || []
                    this.total = res.data.total || 0
                } else {
                    this.$message.error(res.msg || '获取中标候选人公示列表失败')
                }
            }).catch(() => {
                this.loading = false
            })
        },

        // 每页条数变化
        getStatusName(status) {
            const statusMap = {
                0: '未发布',
                1: '待发布',
                2: '已发布',
                3: '已撤回',
                9: '已完成'
            }
            return statusMap[status] || '未知'
        },

        // 状态标签类型
        getStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                2: 'success',
                3: 'danger',
                9: 'success'
            }
            return typeMap[status] || 'info'
        },

        // 详情页状态名称映射
        getDetailStatusName(status) {
            const statusMap = {
                0: '暂存',
                1: '提交',
                9: '发布'
            }
            return statusMap[status] || '未知'
        },

        // 详情页状态标签类型
        getDetailStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                9: 'success'
            }
            return typeMap[status] || 'info'
        },

        // 公示类型名称映射
        getTypeName(typeCode) {
            const typeMap = {
                0: '正常公示',
                1: '更正',
                2: '其他'
            }
            return typeMap[typeCode] || '-'
        },

        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 查看详情
        handleView(row) {
            this.$router.push({
                path: '/bidderHome/winCandidateListDetail',
                query: {
                    projectName: row.projectName,
                    projectCode: row.projectCode,
                    winCandidateBulletinCode: row.winCandidateBulletinCode
                }
            })
        },

        // 每页条数变化
        handleSizeChange(val) {
            this.pageSize = val
            this.pageNum = 1
            this.getWinCandidateList()
        },

        // 当前页变化
        handleCurrentChange(val) {
            this.pageNum = val
            this.getWinCandidateList()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @primary-color;
            border-radius: 2px;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.table-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
}

.pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

/deep/ .action-btn {
    font-weight: 500;

    &:hover {
        color: @primary-color;
    }
}
</style>